// ========================================================================
// ResendVerifyModal.jsx — FINAL SMART VERSION
// Detects: Already verified / Sent / Unknown email (safe non-enumeration)
// ========================================================================

import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

import { useState, useEffect } from "react";
import api from "../utils/api";
import Toast from "./Toast";

export default function ResendVerifyModal({ open, onClose, defaultEmail }) {
  const [email, setEmail] = useState(defaultEmail || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setEmail(defaultEmail || "");
  }, [defaultEmail]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      Toast.error("Please enter your email.");
      return;
    }

    setLoading(true);

    try {
      const res = await api.post("/auth/resend-verify-link", { email });

     const message = res?.data?.message || "";
const msg = message.toLowerCase();

// ---------------------------------------------------------
// ✅ Already verified
// ---------------------------------------------------------
if (msg.includes("already verified")) {
  Toast.info(message);
  localStorage.removeItem("pending_email");
  onClose();
  return;
}

// ---------------------------------------------------------
// ⏳ Cooldown / rate-limit message (10-minute rule)
// ---------------------------------------------------------
if (msg.includes("10 minute") || msg.includes("try again")) {
  Toast.warning(message);
  return; // keep modal open so user can read
}

// ---------------------------------------------------------
// ⛔ Daily limit reached
// ---------------------------------------------------------
if (msg.includes("daily limit")) {
  Toast.warning(message);
  return;
}

// ---------------------------------------------------------
// ✅ Normal resend / unknown email (safe)
// ---------------------------------------------------------
Toast.success(message || "A verification link has been sent.");

localStorage.setItem("pending_email", email);
onClose();


    } catch (err) {
      // ---------------------------------------------------------
      // 🔥 CASE 3 — Server / network error
      // ---------------------------------------------------------
      Toast.error("Unable to resend link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: "90%",
          maxWidth: 420,
          bgcolor: "white",
          p: 4,
          borderRadius: 3,
          mx: "auto",
          mt: "15vh",
          boxShadow: 24,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          textAlign="center"
          sx={{ mb: 2 }}
        >
          Resend Verification Email
        </Typography>

        <Typography
          sx={{
            mb: 2,
            color: "text.secondary",
            fontSize: 14,
            textAlign: "center",
          }}
        >
          Enter your email to receive a new verification link.
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email Address"
            fullWidth
            margin="normal"
            value={email}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
          />

          <Button
            variant="contained"
            fullWidth
            sx={{ py: 1.2, mt: 2 }}
            disabled={loading}
            type="submit"
          >
            {loading ? (
              <CircularProgress size={22} color="inherit" />
            ) : (
              "Resend Link"
            )}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            sx={{ py: 1.2, mt: 1.5 }}
            onClick={onClose}
          >
            Cancel
          </Button>
        </form>
      </Box>
    </Modal>
  );
}
